import { createFeatureSelector, createSelector } from '@ngrx/store';

import { defaultPropertyProfileExportOptions } from '../../constants/profile.constant';
import { propertyProfileFeatureKey, propertyProfileSelectEntities, State } from '../reducers/property-profile.reducer';

export const selectPropertySearchFeature = createFeatureSelector<State>(propertyProfileFeatureKey);

export const selectPropertySearchAddressComponents = createSelector(
  selectPropertySearchFeature,
  (state: State) => state.propertySearchAddressComponents ?? []
);

export const selectKey = createSelector(
  selectPropertySearchFeature,
  (state: State) => state.propertySearchKey ?? 'BOGUS_PROPERTY_KEY'
);

export const selectCurrentPropertyProfileId = createSelector(
  selectPropertySearchFeature,
  (state: State) => state.selectedPropertyProfileId
);

export const selectPropertyProfileEntities = createSelector(selectPropertySearchFeature, propertyProfileSelectEntities);

export const selectPropertyProfile = (id: string) =>
  createSelector(
    selectPropertyProfileEntities,
    (propertyProfileEntities) => propertyProfileEntities[id]?.propertyProfile
  );

export const selectPropertyProfileIsPlatMapAvailable = (id: string) =>
  createSelector(selectPropertyProfileEntities, (propertyProfileEntities) =>
    propertyProfileEntities[id] ? propertyProfileEntities[id].isPlatMapAvailable : false
  );

export const selectPropertyProfileExportPreviewHtml = (id: string) =>
  createSelector(
    selectPropertyProfileEntities,
    (propertyProfileEntities) => propertyProfileEntities[id]?.reportExportPreviewHtml
  );

export const selectPropertyProfileExportOptions = (id: string) =>
  createSelector(selectPropertyProfileEntities, (propertyProfileEntities) => ({
    isDetailsAndCharacteristicsVisible:
      propertyProfileEntities[id]?.isReportExportDetailsAndCharacteristicsVisible ??
      defaultPropertyProfileExportOptions.isReportExportDetailsAndCharacteristicsVisible,
    isPlatMapVisible:
      propertyProfileEntities[id]?.isReportExportPlatMapVisible ??
      defaultPropertyProfileExportOptions.isReportExportPlatMapVisible,
    isSaleInformationVisible:
      propertyProfileEntities[id]?.isReportExportSaleInformationVisible ??
      defaultPropertyProfileExportOptions.isReportExportSaleInformationVisible,
    isSchoolsVisible:
      propertyProfileEntities[id]?.isReportExportSchoolsVisible ??
      defaultPropertyProfileExportOptions.isReportExportSchoolsVisible,
    isTransactionHistoryVisible:
      propertyProfileEntities[id]?.isReportExportTransactionHistoryVisible ??
      defaultPropertyProfileExportOptions.isReportExportTransactionHistoryVisible
  }));

export const selectPropertyProfileMapCenter = (id: string) =>
  createSelector(selectPropertySearchFeature, selectPropertyProfileEntities, (state, propertyProfileEntities) =>
    propertyProfileEntities[id]?.propertyProfile
      ? ({
          lat: parseFloat(propertyProfileEntities[id]?.propertyProfile.latitude ?? ''),
          lng: parseFloat(propertyProfileEntities[id]?.propertyProfile.longitude ?? '')
        } as google.maps.LatLngLiteral)
      : state.mapViewDefaultCenterLocation
  );

export const selectPropertyProfileComparableSales = (id: string) =>
  createSelector(selectPropertySearchFeature, selectPropertyProfileEntities, (state, propertyProfileEntities) =>
    propertyProfileEntities[id]?.propertyProfile ? propertyProfileEntities[id]?.comparableSales : []
  );

export const selectPropertyProfileSchools = (id: string) =>
  createSelector(selectPropertyProfileEntities, (propertyProfileEntities) =>
    propertyProfileEntities[id]?.schools ? propertyProfileEntities[id]?.schools : []
  );

export const selectPropertyProfileSchoolMarkers = (id: string) =>
  createSelector(selectPropertyProfileEntities, (propertyProfileEntities) =>
    propertyProfileEntities[id]?.schoolMarkers ? propertyProfileEntities[id]?.schoolMarkers : []
  );

export const selectPropertyProfileHasSchools = (id: string) =>
  createSelector(
    selectPropertyProfileEntities,
    (propertyProfileEntities) => propertyProfileEntities[id]?.hasSchoolsData
  );

export const selectPropertyProfileSchoolByIndex = (id: string, index: number) =>
  createSelector(selectPropertyProfileSchools(id), (schools) => schools[index]?.data);

export const selectPropertySearchAddressLocation = () =>
  createSelector(selectPropertySearchFeature, (state) => state.propertySearchAddressLocation);

export const selectPropertySearchText = () =>
  createSelector(selectPropertySearchFeature, (state) => state.propertySearchText);

export const selectHistory = () => createSelector(selectPropertySearchFeature, (state) => state.history);
